import { useState, useEffect } from 'react';
import { getGameProgress } from '../utils/storage';
import styles from './DashboardPage.module.css';

const DashboardPage = () => {
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    const fetchProgress = async () => {
      const gameProgress = await getGameProgress();
      setProgress(gameProgress);
    };
    fetchProgress();
  }, []);

  if (!progress) return <div>Loading...</div>;

  return (
    <div className={styles.container}>
      <h1>Dashboard</h1>
      <p>Levels Completed: {progress.completedLevels.length}</p>
      <p>Bricks Earned: {progress.bricks}</p>
      <p>House Stages Built: {progress.houseStages}</p>
    </div>
  );
};

export default DashboardPage;